import { z } from 'zod'
import { HtmlString, IsoDateString } from '../../common'
import { guidSchema } from '../../contracts/_common'
import { AccountGuid } from '../Accounts/Account'
import { ContactGuid } from '../contacts/Contact'
import { JobType } from '../JobTypes/JobTypes'
import { LeadSourceGuid } from '../LeadAttribution/LeadSource'
import { LocationGuid } from '../Locations/Location'
import { Tag } from '../Tags'
import { InstallProjectType } from './JobClass'
import { EquipmentTypeJobLink, JobGuid } from './JobInterfaces'

export type EditJobViewModel = {
  classificationRevision?: number
  jobGuid: JobGuid
  displayId: number
  locationGuid: LocationGuid
  accountGuid: AccountGuid
  jobType: JobType
  installProjectType?: InstallProjectType
  summary: string
  summaryHtml: HtmlString
  pointOfContactGuid: ContactGuid
  isOpportunity: boolean
  isHotLead: boolean
  isMembershipOpportunity: boolean
  isMembershipRenewalOpportunity: boolean
  leadSourceGuid?: LeadSourceGuid
  leadSourceReferringContactGuid?: ContactGuid
  leadSourceAttributionDescription?: string
  equipmentTypeJobLinks: EquipmentTypeJobLink[]
  tagGuids: Tag['tagGuid'][]
  maintenancePlanVisitGuid?: string
  useMaintenancePlanCredit: boolean
  customerPurchaseOrderNumber?: string
  workCompletedAt?: IsoDateString
  businessUnitGuid?: string
  purchaseOrders: {
    purchaseOrderGuid: string
    purchaseOrderNumber: string
  }[]
}

export type CreatedByUserDetails = {
  jobCreatedByUserGuid: string
  jobCreatedByUserName: string
  jobCreatedByUserEmail: string
}

export const ComprehensiveJobDetailsQuerySchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('by-job-guid'), companyGuid: guidSchema, jobGuid: guidSchema }),
  z.object({ type: z.literal('by-job-display-id'), companyGuid: guidSchema, displayId: z.number() }),
  z.object({ type: z.literal('by-account-guid'), companyGuid: guidSchema, accountGuid: guidSchema }),
  z.object({ type: z.literal('by-company-guid'), companyGuid: guidSchema }),
])

export type ComprehensiveJobDetailsQuery = z.infer<typeof ComprehensiveJobDetailsQuerySchema>
